
import { apiFetch } from './api-client'
import { UserCourse, Course } from '@/types/supabase'
import type { 
  GetUserCoursesResponse, 
  GetCourseProgressResponse, 
  CompleteLessonResponse,
  UserCourseDto
} from '@/dto/index'

function mapUserCourse(dto: UserCourseDto & { course: any }): UserCourse {
  return {
    id: dto.id,
    user_id: dto.userId,
    course_id: dto.courseId,
    progress: dto.progress,
    last_lesson_id: dto.lastLessonId,
    completed_lessons: dto.completedLessons,
    created_at: dto.createdAt,
    course: dto.course ? {
      id: dto.course.id,
      title: dto.course.title,
      description: dto.course.description,
      short_description: dto.course.shortDescription,
      price: parseFloat(dto.course.price),
      duration: dto.course.duration,
      level: dto.course.level,
      lesson_count: dto.course.lessonCount,
      image_url: dto.course.imageUrl,
      created_at: dto.course.createdAt,
    } : undefined
  };
}

// Get all courses a user is enrolled in
export async function getUserCourses(_userId: string) {
  try {
    const data = await apiFetch<GetUserCoursesResponse>('/api/user/courses')
    return data.userCourses.map(mapUserCourse)
  } catch (error) {
    console.error('Error fetching user courses:', error)
    return []
  }
}

// Enroll a user in a course
export async function enrollUserInCourse(_userId: string, _courseId: string) {
  // This will be handled by Phase 4 (via payment/webhook).
  // Manual enrollment might not be needed in frontend for users.
  console.warn("enrollUserInCourse not implemented in new API yet");
  return null;
}

// Update user's course progress
export async function updateCourseProgress(
  _userCourseId: string, 
  _progress: number, 
  _lastLessonId: string,
  _completedLessons: string[]
) {
  // We use markLessonAsCompleted instead in the new API
  console.warn("updateCourseProgress: Use markLessonAsCompleted instead");
  return null;
}

// Mark a lesson as completed
export async function markLessonAsCompleted(
  _userCourseId: string, // Unused in new API (inferred from session + courseId)
  lessonId: string,
  courseId?: string
) {
  if (!courseId) {
    console.error('courseId is required for markLessonAsCompleted in the new API');
    return null;
  }
  try {
    const data = await apiFetch<CompleteLessonResponse>(
      `/api/user/courses/${courseId}/lessons/${lessonId}/complete`,
      { method: 'POST' }
    );
    
    if (data.success) {
      // Return a partial UserCourse or similar if caller expects it
      return {
        progress: data.percentage,
        completed_lessons: data.completedLessons,
        last_lesson_id: lessonId
      } as any;
    }
    return null;
  } catch (error) {
    console.error('Error marking lesson as completed:', error)
    return null
  }
}
